var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { ref: "searchbox", on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-2y",
                    defaultEnd: "2M",
                    label: "공포기간",
                    name: "promulgationPeriod",
                  },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.promulgationPeriod,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "promulgationPeriod", $$v)
                    },
                    expression: "searchParam.promulgationPeriod",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "법령 목록",
            tableId: "lawpop",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            isExcelDown: false,
            isFullScreen: false,
            columnSetting: false,
            selection: _vm.popupParam.type,
            rowKey: "mdmLawId",
          },
          on: { linkClick: _vm.linkClick, rowDblclick: _vm.rowDblclick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  props.row.lawLink
                    ? [
                        _c("q-btn", {
                          staticClass: "tableinnerBtn",
                          attrs: {
                            flat: "",
                            icon: "launch",
                            align: "center",
                            color: "blue-6",
                            label: "",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.linkClick(props, col)
                            },
                          },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSELECT", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }